import type { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';
import axios from 'axios';

import { store } from '@/stores';

const axiosInstance = (() => {
  const instance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  });

  instance.interceptors.request.use((config) => {
    const access_token = store.getState().auth.user?.token;

    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  });

  return instance;
})();

const internalAxiosInstance = (() => {
  const instance = axios.create({});

  instance.interceptors.request.use((config) => {
    const access_token = store.getState().auth.user?.token;

    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  });

  return instance;
})();

const method =
  (method: Method, axiosInstance: AxiosInstance) =>
  <T = unknown>(url: string, config?: Omit<AxiosRequestConfig, 'url' | 'method'>): AxiosPromise<T> =>
    axiosInstance(url, { ...config, method });

export const http = {
  get: method('get', axiosInstance),
  post: method('post', axiosInstance),
  patch: method('patch', axiosInstance),
  put: method('put', axiosInstance),
  delete: method('delete', axiosInstance),
} as const;

export const internalHttp = {
  get: method('get', internalAxiosInstance),
  post: method('post', internalAxiosInstance),
  patch: method('patch', internalAxiosInstance),
  put: method('put', internalAxiosInstance),
  delete: method('delete', internalAxiosInstance),
} as const;

const Method = {
  get: 'get',
  post: 'post',
  patch: 'patch',
  put: 'put',
  delete: 'delete',
} as const;
type Method = (typeof Method)[keyof typeof Method];
